<div  class="img-container">
  <div class="white-space"></div>
</div>
